"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = {
    key: 0,
    class: "compose-overlay eh-popup-overlay"
};
var _hoisted_2 = { class: "header-left" };
var _hoisted_3 = { class: "patient-banner" };
var _hoisted_4 = { class: "banner-info" };
var _hoisted_5 = { class: "banner-name" };
var _hoisted_6 = { class: "banner-mrn" };
var _hoisted_7 = { class: "modal-body" };
var _hoisted_8 = { class: "form-group" };
var _hoisted_9 = ["value"];
var _hoisted_10 = { class: "form-group" };
var _hoisted_11 = { class: "meeting-type-grid" };
var _hoisted_12 = ["onClick"];
var _hoisted_13 = { class: "form-group" };
var _hoisted_14 = { class: "calendar" };
var _hoisted_15 = { class: "calendar-header" };
var _hoisted_16 = { class: "cal-title" };
var _hoisted_17 = { class: "calendar-weekdays" };
var _hoisted_18 = { class: "calendar-grid" };
var _hoisted_19 = ["disabled", "title", "onClick"];
var _hoisted_20 = { class: "form-group" };
var _hoisted_21 = { class: "form-label" };
var _hoisted_22 = {
    key: 0,
    class: "slots-loading"
};
var _hoisted_23 = {
    key: 0,
    class: "slots-hint"
};
var _hoisted_24 = {
    key: 1,
    class: "slots-empty"
};
var _hoisted_25 = {
    key: 2,
    class: "time-slots"
};
var _hoisted_26 = ["disabled", "title", "onClick"];
var _hoisted_27 = { class: "form-group" };
var _hoisted_28 = { class: "form-group notify-group" };
var _hoisted_29 = { class: "notify-options" };
var _hoisted_30 = { class: "toggle-text" };
var _hoisted_31 = { class: "toggle-sub" };
var _hoisted_32 = { class: "toggle-text" };
var _hoisted_33 = { class: "toggle-sub" };
var _hoisted_34 = {
    key: 0,
    class: "group-select-wrap"
};
var _hoisted_35 = ["label"];
var _hoisted_36 = ["value"];
var _hoisted_37 = {
    key: 0,
    class: "form-error"
};
var _hoisted_38 = { class: "modal-footer" };
var _hoisted_39 = ["disabled"];
var _hoisted_40 = { class: "footer-right" };
var _hoisted_41 = ["disabled"];
var _hoisted_42 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spinning"
};
var vue_3 = require("vue");
var patientCardsStore_1 = require("../../../stores/patientCardsStore"); //'@/stores/patientCardsStore'
var appointmentApiService_1 = require("../../../services/appointmentApiService"); //'@/services/appointmentApiService'
var privilegesApi_1 = require("@/api/privilegesApi");
var useSchedulingAccess_1 = require("@/composables/useSchedulingAccess");
var vuex_1 = require("vuex");
// Access the Vuex store
exports.default = (0, vue_1.defineComponent)({
    __name: 'AppointmentModule',
    props: {
        show: { type: Boolean },
        patient: {}
    },
    emits: ["close", "scheduled", "updated", "cancelled"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var vustore = (0, vuex_1.useStore)();
        // Map Vuex getters
        var allData = (0, vue_3.computed)(function () { return vustore.getters['login/getAllData']; });
        var props = __props;
        var staffContext = (0, vue_3.computed)(function () {
            var _a = (0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(allData.value), accountnumber = _a.accountnumber, unique_ID = _a.unique_ID;
            return { externId: unique_ID, externId2: accountnumber };
        });
        // This modal is mounted from PatientCards.vue, outside ManageScheduling.vue's
        // tree, so it resolves its own access rather than receiving one as a prop --
        // see filterStaffForAccess's header for why the provider picker below needs it.
        var schedulingAccess = (0, useSchedulingAccess_1.useSchedulingAccess)().access;
        var visibleProviders = (0, vue_3.computed)(function () { return (0, useSchedulingAccess_1.filterStaffForAccess)(store.providers, schedulingAccess.value); });
        var emit = __emit;
        var store = (0, patientCardsStore_1.usePatientCardsStore)();
        var modalRef = (0, vue_3.ref)(null);
        var meetingTypes = patientCardsStore_1.MEETING_TYPES;
        var groupOption = (0, vue_3.ref)([]);
        var isSaving = (0, vue_3.ref)(false);
        var saveError = (0, vue_3.ref)('');
        var existingAppointment = (0, vue_3.ref)(null);
        //options array | populated from _newGetPatientGroups, one optgroup per care-team group
        var groupoptions = (0, vue_3.ref)([]);
        var individualGpMembers = (0, vue_3.ref)([]);
        var form = (0, vue_3.reactive)({
            providerId: '',
            meetingType: 'in-person',
            date: '',
            time: '',
            reason: '',
            notifyEmail: true,
            notifySms: false
        });
        var isManaging = (0, vue_3.computed)(function () { return !!existingAppointment.value; });
        var currentStatus = (0, vue_3.computed)(function () { var _a; return (_a = existingAppointment.value) === null || _a === void 0 ? void 0 : _a.status; });
        var statusLabel = (0, vue_3.computed)(function () {
            var s = currentStatus.value;
            if (s === 'approved')
                return 'Approved';
            if (s === 'pending')
                return 'Pending Approval';
            return '';
        });
        var statusIcon = (0, vue_3.computed)(function () {
            return currentStatus.value === 'approved' ? 'glyphicon-ok-circle' : 'glyphicon-hourglass';
        });
        var patientInitials = (0, vue_3.computed)(function () {
            if (!props.patient)
                return '';
            return "".concat(props.patient.firstName[0]).concat(props.patient.lastName[0]).toUpperCase();
        });
        var canSave = (0, vue_3.computed)(function () {
            return form.providerId && form.date && form.time && form.meetingType;
        });
        // ---- Calendar logic ----
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var viewDate = (0, vue_3.reactive)({ year: today.getFullYear(), month: today.getMonth() });
        var weekdays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
        // Pre-fetched provider availability meta — loaded when a provider is selected.
        // Used to pre-mark calendar days as unavailable without hitting the backend
        // once per date, keeping the calendar cheap (2 calls instead of 31).
        var providerTimeOff = (0, vue_3.ref)([]);
        var providerRules = (0, vue_3.ref)([]);
        function loadProviderMeta() {
            return __awaiter(this, void 0, void 0, function () {
                var _a, timeOffData, rulesData;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!form.providerId || !staffContext.value.externId2) {
                                providerTimeOff.value = [];
                                providerRules.value = [];
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, Promise.all([
                                    (0, appointmentApiService_1.getTimeOff)(staffContext.value.externId2, form.providerId),
                                    (0, appointmentApiService_1.getAvailabilityRules)(staffContext.value.externId2, form.providerId)
                                ])];
                        case 1:
                            _a = _b.sent(), timeOffData = _a[0], rulesData = _a[1];
                            providerTimeOff.value = Array.isArray(timeOffData) ? timeOffData : [];
                            providerRules.value = Array.isArray(rulesData) ? rulesData : [];
                            return [2 /*return*/];
                    }
                });
            });
        }
        // Reload meta whenever the provider selection changes
        (0, vue_3.watch)(function () { return form.providerId; }, function () { loadProviderMeta(); });
        var monthLabel = (0, vue_3.computed)(function () {
            return new Date(viewDate.year, viewDate.month).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        });
        var calendarDays = (0, vue_3.computed)(function () {
            var firstDay = new Date(viewDate.year, viewDate.month, 1).getDay();
            var daysInMonth = new Date(viewDate.year, viewDate.month + 1, 0).getDate();
            var days = [];
            for (var i = 0; i < firstDay; i++) {
                days.push({ date: null, label: '', dateStr: '', isToday: false, isPast: false, isTimeOff: false, hasNoRules: false });
            }
            var _loop_1 = function (d) {
                var dateObj = new Date(viewDate.year, viewDate.month, d);
                dateObj.setHours(0, 0, 0, 0);
                var dateStr = "".concat(viewDate.year, "-").concat(String(viewDate.month + 1).padStart(2, '0'), "-").concat(String(d).padStart(2, '0'));
                var dayOfWeek = dateObj.getDay();
                // All-day time off: startTime is null on the matching date
                var isTimeOff = providerTimeOff.value.some(function (t) { return t.offDate === dateStr && (t.startTime === null || t.startTime === ''); });
                // No weekly availability rule for this weekday at all
                var hasNoRules = form.providerId
                    ? !providerRules.value.some(function (r) { return r.dayOfWeek === dayOfWeek; })
                    : false;
                days.push({
                    date: d, label: String(d),
                    dateStr: dateStr,
                    isToday: dateObj.getTime() === today.getTime(),
                    isPast: dateObj.getTime() < today.getTime(),
                    isTimeOff: isTimeOff,
                    hasNoRules: hasNoRules
                });
            };
            for (var d = 1; d <= daysInMonth; d++) {
                _loop_1(d);
            }
            return days;
        });
        //Fetch Groups From Back-end//
        function findPatientGroupss() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!props.patient) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, (0, appointmentApiService_1.findPatientGroups)(props.patient.id)];
                        case 1:
                            res = _b.sent();
                            console.log("Appointment Module - Demo of payload for Groups");
                            console.log(res);
                            // Keep groups separate (one optgroup per care-team group); drop empty ones.
                            groupoptions.value = ((_a = res === null || res === void 0 ? void 0 : res.groups) !== null && _a !== void 0 ? _a : []).filter(function (group) { var _a; return ((_a = group.members) === null || _a === void 0 ? void 0 : _a.length) > 0; });
                            return [2 /*return*/];
                    }
                });
            });
        }
        // groupOption only holds selected emails (native <select> values must be primitives) —
        // resolve back to {name, email, phone} against groupoptions so the backend can notify
        // by either channel (notifyEmail and/or notifySms). Shared with SchedulingCalendar.vue's
        // own group-notify picker via resolveGroupMembers() in appointmentApiService.ts.
        function resolveSelectedGroupMembers() {
            return (0, appointmentApiService_1.resolveGroupMembers)(groupoptions.value, groupOption.value);
        }
        // ---- Availability-driven time slots ----
        // Fetched from the API service whenever provider + date are chosen.
        var availableSlots = (0, vue_3.ref)([]);
        var loadingSlots = (0, vue_3.ref)(false);
        function loadAvailability() {
            return __awaiter(this, void 0, void 0, function () {
                var res, ownSlotTime_1, stillValid;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            // Need both a provider and a date to query availability.
                            if (!form.providerId || !form.date) {
                                availableSlots.value = [];
                                return [2 /*return*/];
                            }
                            loadingSlots.value = true;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, (0, appointmentApiService_1.getAvailability)(staffContext.value.externId2, form.providerId, form.date)
                                // When managing an existing appointment: the patient's own booked slot shows
                                // as unavailable (it IS in the booked list) but should display as selectable
                                // so they can keep or change it without confusion. Mark it available so the
                                // purple "active" class applies cleanly instead of strikethrough+faded.
                            ];
                        case 2:
                            res = _c.sent();
                            ownSlotTime_1 = ((_a = existingAppointment.value) === null || _a === void 0 ? void 0 : _a.date) === form.date
                                ? (_b = existingAppointment.value) === null || _b === void 0 ? void 0 : _b.time
                                : null;
                            availableSlots.value = res.slots.map(function (s) {
                                return ownSlotTime_1 && s.value === ownSlotTime_1 ? __assign(__assign({}, s), { available: true }) : s;
                            });
                            stillValid = availableSlots.value.find(function (s) { return s.value === form.time && s.available; });
                            if (form.time && !stillValid) {
                                form.time = '';
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            loadingSlots.value = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        // Re-fetch availability whenever the provider or date changes.
        (0, vue_3.watch)(function () { return [form.providerId, form.date]; }, function () {
            loadAvailability();
        });
        function prevMonth() {
            if (viewDate.month === 0) {
                viewDate.month = 11;
                viewDate.year--;
            }
            else {
                viewDate.month--;
            }
        }
        function nextMonth() {
            if (viewDate.month === 11) {
                viewDate.month = 0;
                viewDate.year++;
            }
            else {
                viewDate.month++;
            }
        }
        function selectDate(dateStr) {
            form.date = dateStr;
        }
        // ---- Drag logic ----
        var position = (0, vue_3.reactive)({ x: 100, y: 60 });
        var dragOffset = (0, vue_3.reactive)({ x: 0, y: 0 });
        var isDragging = (0, vue_3.ref)(false);
        function startDrag(e) {
            isDragging.value = true;
            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
            dragOffset.x = clientX - position.x;
            dragOffset.y = clientY - position.y;
            document.addEventListener('mousemove', onDrag);
            document.addEventListener('mouseup', stopDrag);
            document.addEventListener('touchmove', onDrag);
            document.addEventListener('touchend', stopDrag);
        }
        function onDrag(e) {
            if (!isDragging.value)
                return;
            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
            position.x = Math.max(0, Math.min(clientX - dragOffset.x, window.innerWidth - 380));
            position.y = Math.max(0, Math.min(clientY - dragOffset.y, window.innerHeight - 100));
        }
        function stopDrag() {
            isDragging.value = false;
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('touchend', stopDrag);
        }
        // ---- Open / reset ----
        (0, vue_3.watch)(function () { return props.show; }, function (show) {
            if (show && props.patient) {
                saveError.value = '';
                providerTimeOff.value = [];
                providerRules.value = [];
                position.x = Math.max(20, (window.innerWidth - 480) / 2);
                position.y = Math.max(20, (window.innerHeight - 640) / 2);
                var existing = store.getAppointmentForPatient(props.patient.id);
                if (existing) {
                    existingAppointment.value = existing;
                    form.providerId = existing.providerId;
                    form.meetingType = existing.meetingType;
                    form.date = existing.date;
                    form.time = existing.time;
                    form.reason = existing.reason || '';
                    form.notifyEmail = existing.notifyEmail;
                    form.notifySms = existing.notifySms;
                    var _a = existing.date.split('-').map(Number), y = _a[0], m = _a[1];
                    viewDate.year = y;
                    viewDate.month = m - 1;
                }
                else {
                    existingAppointment.value = null;
                    form.providerId = store.currentProvider.id;
                    form.meetingType = 'in-person';
                    form.date = '';
                    form.time = '';
                    form.reason = '';
                    form.notifyEmail = true;
                    form.notifySms = false;
                    viewDate.year = today.getFullYear();
                    viewDate.month = today.getMonth();
                }
            }
        });
        function handleSave() {
            return __awaiter(this, void 0, void 0, function () {
                var provider, patientName, patsubaccountnumber, res, res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!canSave.value || !props.patient)
                                return [2 /*return*/];
                            saveError.value = '';
                            isSaving.value = true;
                            provider = store.providers.find(function (p) { return p.id === form.providerId; });
                            patientName = "".concat(props.patient.firstName, " ").concat(props.patient.lastName);
                            patsubaccountnumber = props.patient.psersonalID;
                            console.log('AppointmentModule handleSave', { isManaging: isManaging.value, form: form });
                            if (!(isManaging.value && existingAppointment.value)) return [3 /*break*/, 2];
                            return [4 /*yield*/, store.updateAppointment(existingAppointment.value.id, {
                                    patientId: props.patient.id,
                                    providerId: form.providerId,
                                    providerName: provider.name,
                                    date: form.date,
                                    time: form.time,
                                    meetingType: form.meetingType,
                                    reason: form.reason,
                                    notifyEmail: form.notifyEmail,
                                    notifySms: form.notifySms,
                                    notifyGroupMembers: (form.notifyEmail || form.notifySms) ? resolveSelectedGroupMembers() : []
                                })];
                        case 1:
                            res = _a.sent();
                            isSaving.value = false;
                            if (!res.success) {
                                saveError.value = 'Could not save changes. Please try again.';
                                return [2 /*return*/];
                            }
                            emit('updated', { patientName: patientName });
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, store.scheduleAppointment({
                                patientId: props.patient.id,
                                providerId: form.providerId,
                                providerName: provider.name,
                                date: form.date,
                                time: form.time,
                                meetingType: form.meetingType,
                                reason: form.reason,
                                notifyEmail: form.notifyEmail,
                                notifySms: form.notifySms,
                                notifyGroupMembers: (form.notifyEmail || form.notifySms) ? resolveSelectedGroupMembers() : []
                            })];
                        case 3:
                            res = _a.sent();
                            isSaving.value = false;
                            if (!res.success) {
                                saveError.value = 'Could not schedule this appointment. Please try again.';
                                return [2 /*return*/];
                            }
                            emit('scheduled', {
                                patientName: patientName,
                                date: form.date,
                                notifyEmail: form.notifyEmail,
                                notifySms: form.notifySms
                            });
                            _a.label = 4;
                        case 4:
                            emit('close');
                            return [2 /*return*/];
                    }
                });
            });
        }
        function handleCancel() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!existingAppointment.value || !props.patient)
                                return [2 /*return*/];
                            if (!confirm('Cancel this appointment? This cannot be undone.'))
                                return [2 /*return*/];
                            saveError.value = '';
                            isSaving.value = true;
                            console.log('AppointmentModule handleCancel', existingAppointment.value.id);
                            return [4 /*yield*/, store.cancelAppointment(existingAppointment.value.id)];
                        case 1:
                            res = _a.sent();
                            isSaving.value = false;
                            if (!res.success) {
                                saveError.value = 'Could not cancel this appointment. Please try again.';
                                return [2 /*return*/];
                            }
                            emit('cancelled', { patientName: "".concat(props.patient.firstName, " ").concat(props.patient.lastName) });
                            emit('close');
                            return [2 /*return*/];
                    }
                });
            });
        }
        function handleClose() {
            emit('close');
        }
        (0, vue_3.onUnmounted)(function () {
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('touchend', stopDrag);
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                    default: (0, vue_2.withCtx)(function () {
                        var _a, _b, _c, _d, _e, _f;
                        return [
                            (_ctx.show)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                                    (0, vue_2.createElementVNode)("div", {
                                        ref_key: "modalRef",
                                        ref: modalRef,
                                        class: "compose-modal appointment-modal eh-popup-panel",
                                        style: (0, vue_2.normalizeStyle)({ left: position.x + 'px', top: position.y + 'px' })
                                    }, [
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "modal-header",
                                            onMousedown: startDrag,
                                            onTouchstart: startDrag
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                                _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-calendar" }, null, -1)),
                                                (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(isManaging.value ? 'Manage Appointment' : 'Schedule Appointment'), 1)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", { class: "header-actions" }, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "header-btn close",
                                                    title: "Close",
                                                    onClick: handleClose
                                                }, __spreadArray([], (_cache[8] || (_cache[8] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-lg" }, null, -1)
                                                ])), true))
                                            ])
                                        ], 32),
                                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: "banner-avatar",
                                                style: (0, vue_2.normalizeStyle)({ background: (_a = _ctx.patient) === null || _a === void 0 ? void 0 : _a.avatarColor })
                                            }, (0, vue_2.toDisplayString)(patientInitials.value), 5),
                                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)((_b = _ctx.patient) === null || _b === void 0 ? void 0 : _b.firstName) + " " + (0, vue_2.toDisplayString)((_c = _ctx.patient) === null || _c === void 0 ? void 0 : _c.lastName), 1),
                                                (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)((_d = _ctx.patient) === null || _d === void 0 ? void 0 : _d.mrn), 1)
                                            ]),
                                            (isManaging.value && currentStatus.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                    key: 0,
                                                    class: (0, vue_2.normalizeClass)(["status-pill", currentStatus.value])
                                                }, [
                                                    (0, vue_2.createElementVNode)("span", {
                                                        class: (0, vue_2.normalizeClass)(["glyphicon", statusIcon.value])
                                                    }, null, 2),
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(statusLabel.value), 1)
                                                ], 2))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                                _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("label", { class: "form-label" }, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-user" }),
                                                    (0, vue_2.createTextVNode)(" Provider ")
                                                ], -1)),
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((form.providerId) = $event); }),
                                                    class: "form-select"
                                                }, [
                                                    _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("option", {
                                                        value: "",
                                                        disabled: ""
                                                    }, "Select a provider...", -1)),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(visibleProviders.value, function (prov) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                            key: prov.id,
                                                            value: prov.id
                                                        }, (0, vue_2.toDisplayString)(prov.name) + " — " + (0, vue_2.toDisplayString)(prov.specialty), 9, _hoisted_9));
                                                    }), 128))
                                                ], 512), [
                                                    [vue_2.vModelSelect, form.providerId]
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                                _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("label", { class: "form-label" }, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-tags" }),
                                                    (0, vue_2.createTextVNode)(" Meeting Type ")
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(meetingTypes), function (type) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                            key: type.value,
                                                            type: "button",
                                                            class: (0, vue_2.normalizeClass)(["meeting-type-btn", { active: form.meetingType === type.value }]),
                                                            onClick: function ($event) { return (form.meetingType = type.value); }
                                                        }, [
                                                            (0, vue_2.createElementVNode)("span", {
                                                                class: (0, vue_2.normalizeClass)(["glyphicon", type.icon])
                                                            }, null, 2),
                                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(type.label), 1)
                                                        ], 10, _hoisted_12));
                                                    }), 128))
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                                _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("label", { class: "form-label" }, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-calendar" }),
                                                    (0, vue_2.createTextVNode)(" Select Date ")
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                                        (0, vue_2.createElementVNode)("button", {
                                                            type: "button",
                                                            class: "cal-nav",
                                                            onClick: prevMonth
                                                        }, __spreadArray([], (_cache[12] || (_cache[12] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-left" }, null, -1)
                                                        ])), true)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)(monthLabel.value), 1),
                                                        (0, vue_2.createElementVNode)("button", {
                                                            type: "button",
                                                            class: "cal-nav",
                                                            onClick: nextMonth
                                                        }, __spreadArray([], (_cache[13] || (_cache[13] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-right" }, null, -1)
                                                        ])), true))
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weekdays, function (d) {
                                                            return (0, vue_2.createElementVNode)("span", { key: d }, (0, vue_2.toDisplayString)(d), 1);
                                                        }), 64))
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(calendarDays.value, function (day, idx) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                key: idx,
                                                                type: "button",
                                                                class: (0, vue_2.normalizeClass)(["cal-day", {
                                                                        empty: !day.date,
                                                                        today: day.isToday,
                                                                        selected: day.dateStr === form.date,
                                                                        disabled: day.isPast || day.isTimeOff || day.hasNoRules,
                                                                        'time-off': day.isTimeOff,
                                                                        'no-rules': day.hasNoRules && !day.isTimeOff
                                                                    }]),
                                                                disabled: !day.date || day.isPast || day.isTimeOff || day.hasNoRules,
                                                                title: day.isTimeOff ? 'Time off — no availability'
                                                                    : day.hasNoRules ? 'No hours configured for this day'
                                                                        : '',
                                                                onClick: function ($event) { return (day.date && !day.isPast && !day.isTimeOff && !day.hasNoRules && selectDate(day.dateStr)); }
                                                            }, (0, vue_2.toDisplayString)(day.label), 11, _hoisted_19));
                                                        }), 128))
                                                    ])
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_21, [
                                                    _cache[16] || (_cache[16] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-time" }, null, -1)),
                                                    _cache[17] || (_cache[17] = (0, vue_2.createTextVNode)(" Select Time ", -1)),
                                                    (loadingSlots.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_22, __spreadArray([], (_cache[15] || (_cache[15] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-refresh spinning" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" checking availability... ", -1)
                                                        ])), true)))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ]),
                                                (!form.date)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_23, "Select a date to see available times."))
                                                    : (!loadingSlots.value && availableSlots.value.length === 0)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_24, __spreadArray([], (_cache[18] || (_cache[18] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ban-circle" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" This provider has no availability on this date. ", -1)
                                                        ])), true)))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(availableSlots.value, function (slot) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                    key: slot.value,
                                                                    type: "button",
                                                                    class: (0, vue_2.normalizeClass)(["time-slot", { active: form.time === slot.value, unavailable: !slot.available }]),
                                                                    disabled: !slot.available,
                                                                    title: !slot.available ? 'Unavailable (booked or time off)' : '',
                                                                    onClick: function ($event) { return (slot.available && (form.time = slot.value)); }
                                                                }, (0, vue_2.toDisplayString)(slot.label), 11, _hoisted_26));
                                                            }), 128))
                                                        ]))
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                                _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("label", { class: "form-label" }, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-pencil" }),
                                                    (0, vue_2.createTextVNode)(" Reason / Notes "),
                                                    (0, vue_2.createElementVNode)("span", { class: "optional" }, "(optional)")
                                                ], -1)),
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((form.reason) = $event); }),
                                                    class: "form-textarea",
                                                    placeholder: "Add a reason or notes for this appointment...",
                                                    rows: "2"
                                                }, null, 512), [
                                                    [vue_2.vModelText, form.reason]
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                                _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("label", { class: "form-label" }, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-bell" }),
                                                    (0, vue_2.createTextVNode)(" Notify Patient ")
                                                ], -1)),
                                                _cache[29] || (_cache[29] = (0, vue_2.createElementVNode)("p", { class: "notify-desc" }, "Send the patient a confirmation of this scheduled appointment.", -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_29, [
                                                    (0, vue_2.createElementVNode)("label", {
                                                        class: (0, vue_2.normalizeClass)(["notify-toggle", { active: form.notifyEmail }])
                                                    }, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "checkbox",
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((form.notifyEmail) = $event); }),
                                                            onChange: _cache[3] || (_cache[3] = function ($event) { return (findPatientGroupss()); })
                                                        }, null, 544), [
                                                            [vue_2.vModelCheckbox, form.notifyEmail]
                                                        ]),
                                                        _cache[21] || (_cache[21] = (0, vue_2.createElementVNode)("span", { class: "toggle-icon email" }, [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope bi-envelope" })
                                                        ], -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_30, [
                                                            _cache[20] || (_cache[20] = (0, vue_2.createElementVNode)("span", { class: "toggle-title" }, "Email", -1)),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_31, (0, vue_2.toDisplayString)((_e = _ctx.patient) === null || _e === void 0 ? void 0 : _e.email), 1)
                                                        ]),
                                                        _cache[22] || (_cache[22] = (0, vue_2.createElementVNode)("span", { class: "toggle-check glyphicon glyphicon-ok" }, null, -1))
                                                    ], 2),
                                                    (0, vue_2.createElementVNode)("label", {
                                                        class: (0, vue_2.normalizeClass)(["notify-toggle", { active: form.notifySms }])
                                                    }, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "checkbox",
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((form.notifySms) = $event); }),
                                                            onChange: _cache[5] || (_cache[5] = function ($event) { return (findPatientGroupss()); })
                                                        }, null, 544), [
                                                            [vue_2.vModelCheckbox, form.notifySms]
                                                        ]),
                                                        _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("span", { class: "toggle-icon sms" }, [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment bi-chat" })
                                                        ], -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_32, [
                                                            _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("span", { class: "toggle-title" }, "SMS / Text", -1)),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_33, (0, vue_2.toDisplayString)((_f = _ctx.patient) === null || _f === void 0 ? void 0 : _f.phone), 1)
                                                        ]),
                                                        _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("span", { class: "toggle-check glyphicon glyphicon-ok" }, null, -1))
                                                    ], 2),
                                                    (form.notifyEmail || form.notifySms)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_34, [
                                                            _cache[27] || (_cache[27] = (0, vue_2.createElementVNode)("span", { class: "group-select-label" }, "Patient Groups", -1)),
                                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                                multiple: "",
                                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((groupOption).value = $event); }),
                                                                class: "group-select"
                                                            }, [
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(groupoptions.value, function (group) {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("optgroup", {
                                                                        key: group.groupId,
                                                                        label: group.groupName
                                                                    }, [
                                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(group.members, function (member) {
                                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                                key: member.pid,
                                                                                value: member.email
                                                                            }, (0, vue_2.toDisplayString)(member.patientName), 9, _hoisted_36));
                                                                        }), 128))
                                                                    ], 8, _hoisted_35));
                                                                }), 128)),
                                                                _cache[26] || (_cache[26] = (0, vue_2.createElementVNode)("optgroup", { label: "All Group Members" }, [
                                                                    (0, vue_2.createElementVNode)("option", { value: "All" }, "All Members")
                                                                ], -1))
                                                            ], 512), [
                                                                [vue_2.vModelSelect, groupOption.value]
                                                            ])
                                                        ]))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ])
                                            ])
                                        ]),
                                        (saveError.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_37, (0, vue_2.toDisplayString)(saveError.value), 1))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_38, [
                                            (isManaging.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                    key: 0,
                                                    class: "btn-danger",
                                                    onClick: handleCancel,
                                                    disabled: isSaving.value
                                                }, __spreadArray([], (_cache[30] || (_cache[30] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-trash" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" Cancel Appt ", -1)
                                                ])), true), 8, _hoisted_39))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (0, vue_2.createElementVNode)("div", _hoisted_40, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-cancel",
                                                    onClick: handleClose
                                                }, "Close"),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-save",
                                                    onClick: handleSave,
                                                    disabled: !canSave.value || isSaving.value
                                                }, [
                                                    (isSaving.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_42))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                            key: 1,
                                                            class: (0, vue_2.normalizeClass)(["glyphicon", isManaging.value ? 'glyphicon-floppy-disk' : 'glyphicon-calendar'])
                                                        }, null, 2)),
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(isSaving.value ? 'Saving...' : (isManaging.value ? 'Update Appointment' : 'Request Appointment')), 1)
                                                ], 8, _hoisted_41)
                                            ])
                                        ])
                                    ], 4)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ];
                    }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
